import { call, put } from 'redux-saga/effects';

import { $httpRootApi } from '@core/http-client';
import { societySegmentActions } from '@redux/reducers/common/society-segments/societySegmentsReducer';
import { getDefaultError } from '@shared/utils/common';

export function* getSocietySegmentsSaga() {
  try {
    yield put(societySegmentActions.setSocietySegmentsLoading());
    const { data } = yield call(() => $httpRootApi.get(`segments/insights`));

    yield put(societySegmentActions.getSocietySegmentsSuccess(data.data));
  } catch (e) {
    yield put(societySegmentActions.getSocietySegmentsFailure(getDefaultError(e?.response?.data?.message)));
  }
}
